import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import Root from 'app/Root';

const root = createRoot(document.getElementById('root'));
root.render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
